import { render, staticRenderFns } from "./firmDetails.vue?vue&type=template&id=a69a3d6a&scoped=true&"
import script from "./firmDetails.vue?vue&type=script&lang=js&"
export * from "./firmDetails.vue?vue&type=script&lang=js&"
import style0 from "./firmDetails.vue?vue&type=style&index=0&id=a69a3d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69a3d6a",
  null
  
)

export default component.exports